import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export interface BasketItem {
  id: string;
  columnName: string;
  issueTitle: string;
  severity: 'low' | 'medium' | 'high';
  recommendations?: string[]; // Goal keys recommended for this issue
}

export type FloatingBasketMode = 'cleaning' | 'configuration';

@Component({
  selector: 'app-floating-basket',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule
  ],
  templateUrl: './floating-basket.component.html',
  styleUrls: ['./floating-basket.component.scss']
})
export class FloatingBasketComponent {
  @Input() mode: FloatingBasketMode = 'cleaning';
  @Input() items: BasketItem[] = [];
  @Input() totalCount: number = 0;
  @Input() selectedDatasources = 0;
  @Input() selectedOptions = 0;
  @Input() creatingWorkflow: boolean = false;
  @Input() workflowProgress: { current: number; total: number } | null = null;
  @Output() viewSelected = new EventEmitter<void>();
  @Output() selectAll = new EventEmitter<void>();
  @Output() startWorkflow = new EventEmitter<void>();

  get itemCount(): number {
    return this.items.length;
  }

  get highSeverityCount(): number {
    return this.items.filter(item => item.severity === 'high').length;
  }

  get mediumSeverityCount(): number {
    return this.items.filter(item => item.severity === 'medium').length;
  }

  get lowSeverityCount(): number {
    return this.items.filter(item => item.severity === 'low').length;
  }

  onViewSelected(): void {
    this.viewSelected.emit();
  }

  onSelectAll(): void {
    this.selectAll.emit();
  }

  onStartWorkflow(): void {
    this.startWorkflow.emit();
  }
}
